import { Fragment } from 'react';

import { Divider, Flex, Skeleton, Text } from '../';

export interface InfoStatsRowProps {
  statItems: { value: string; label: string }[];
  loading?: boolean;
}

export default function InfoStatsRow(props: Readonly<InfoStatsRowProps>) {
  const { statItems, loading: isLoading = false } = props;
  return (
    <Flex
      sx={(theme) => ({
        backgroundColor: theme.palette.grey[100],
        p: theme.spacing(2),
        borderRadius: theme.shape.rounded(2),
        gap: theme.spacing(1),
        alignItems: 'center',
        justifyContent: 'space-evenly',
      })}
    >
      {statItems.map((item, index) => (
        <Fragment key={`${item.label}-${item.value}`}>
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              alignItems: 'center',
              minWidth: '48px',
              gap: theme.spacing(1),
            })}
          >
            {isLoading ? <Skeleton width='100%' /> : <Text variant='h5'>{item.value}</Text>}
            <Text variant='caption'>{item.label}</Text>
          </Flex>
          {index !== statItems.length - 1 ? <Divider orientation='vertical' flexItem /> : null}
        </Fragment>
      ))}
    </Flex>
  );
}
